module.exports = __webpack_public_path__ + "static/media/24UHCHR15.e530513f.jpg";